import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import _ from 'lodash';
import { MCAPSLeadershipROB } from 'src/manageAction/interfaces/MCAPSLeadershipROB';
import { postArtemisAction } from '../../services/CreatePostAction';
import { IDropdownOption } from '@fluentui/react';

export interface ITemporaryLocalStates {
  currentRemoteUrl: string;
}

export interface ISetActionDataSlice extends ITemporaryLocalStates {
  MCAPSROBDetails: MCAPSLeadershipROB;
  workScopeItems: any;
}

const tempLocalStates = {
  currentRemoteUrl: '',
};

const initialState = {
  MCAPSROBDetails: {},
  workScopeItems: [],
  ...tempLocalStates,
} as ISetActionDataSlice;

export const createActionSlice = createSlice({
  name: 'createActionData',
  initialState,
  reducers: {
    // getMCAPSROBDetails:(state, action: PayloadAction<MCAPSLeadershipROB>) => {
    //     state.MCAPSROBDetails = initialState;
    // },
    setMCAPSROBDetails: (state, action: PayloadAction<MCAPSLeadershipROB>) => {
      state.MCAPSROBDetails = action.payload;
    },
    setWorkScopeItem: (state, action: any) => {
        state.workScopeItems = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(postArtemisAction.endpoints.createRAIDItems.matchFulfilled, (state, action) => {
      
    });
  },
});

export default createActionSlice.reducer;

export const { 
  setMCAPSROBDetails,
  setWorkScopeItem
 } = createActionSlice.actions;
